import React, { Component } from "react";
import {
  DropdownButton,
  MenuItem,
  FormGroup,
  Col,
  ControlLabel,
  ButtonGroup
} from "react-bootstrap";

const BUTTONS = ["Default", "Primary", "Success", "Info", "Warning", "Danger"];
const styles = {
  customWidth: {
    width: 100 + "%"
  }
};

export class Dropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title
        ? this.props.title
        : this.props.proprieties[0].placeholder
    };
    this.onSelect = this.onSelect.bind(this);
  }

  onSelect = eventKey => {
    this.setState({title: eventKey});
    this.props.onValueChange(eventKey,this.props.statekey);
  };

  render() {
    const { hidden } = this.props;
    var row = [];
    var style = {};
    if(hidden===true) {
      style.display = 'none';
    }
    for (var i = 0; i < this.props.ncols.length; i++) {
      row.push(
        <div key={i} className={this.props.ncols[i]}>
          {/* <FieldGroup {...this.props.proprieties[i]} /> */}

          <FormGroup style={{ marginBottom: -10 + "px" }}>
            <Col
              componentClass={ControlLabel}
              style={{ marginTop: 5 + "px" }}
              md={5}
            >
              {this.props.proprieties[i].label}
            </Col>
            <Col md={7}>
              <ButtonGroup justified>
                <DropdownButton
                  style={{ width: 100 + "%" }}
                  bsStyle="default"
                  bsSize="xsmall"
                  title={this.state.title}
                  key={1}
                  id={`dropdown-basic`}
                  disabled={this.props.disabled}
                >
                  {this.props.proprieties[i].children.map((item, key) => {
                    return (
                      <MenuItem
                        eventKey={item}
                        onSelect={this.onSelect}
                        key={key}
                        // active
                      >
                        {item}
                      </MenuItem>
                    );
                  })}
                </DropdownButton>
              </ButtonGroup>
            </Col>
          </FormGroup>
        </div>
      );
    }
    return <div style={style}>{row}</div>;
  }
}

export default Dropdown;
